import { render, staticRenderFns } from "./Viajes.vue?vue&type=template&id=3134e55b"
import script from "./Viajes.vue?vue&type=script&lang=js"
export * from "./Viajes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports